import { Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, title, subtitle, children }) => (
  <section className="bg-secondary border-b border-border">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-24">
      <Reveal>
        {eyebrow && (
          <p className="text-accent font-bold uppercase tracking-wide mb-3">{eyebrow}</p>
        )}
        <h1 className="font-heading font-extrabold text-foreground text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-muted-foreground text-lg md:text-xl leading-relaxed max-w-2xl">
            {subtitle}
          </p>
        )}
        {children}
      </Reveal>
    </div>
  </section>
);
